import { render, staticRenderFns } from "./PreviewInstructions.vue?vue&type=template&id=9119d96c&scoped=true&"
import script from "./PreviewInstructions.vue?vue&type=script&lang=js&"
export * from "./PreviewInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9119d96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
